// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2NCa2","alertIcon":"ConfirmModal_alertIcon__GMC1B"};